<!-- Navigation menu-->
<app-menu></app-menu>

<!-- Map -->
<router-outlet></router-outlet>

<!-- Table -->
<app-table></app-table>

<!-- Print -->
<app-print></app-print>